export default "__VITE_ASSET__BFjzzri5__"